import { render, staticRenderFns } from "./DeliveriesSyncPartnerStatusModal.vue?vue&type=template&id=42c0806a&lang=pug&"
import script from "./DeliveriesSyncPartnerStatusModal.vue?vue&type=script&lang=js&"
export * from "./DeliveriesSyncPartnerStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports